export default function File({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={18}
      fill={color}
      className="bi bi-file-earmark-text-fill"
    >
      <path
        fill="#000D5B"
        d="M12.788 0H.964A.964.964 0 0 0 0 .964V13.21l.003.024c0 .014.004.03.004.045.003.01.007.02.01.034l.01.038c.004.01.01.02.018.034.007.01.01.021.017.031.007.014.017.024.027.035.007.007.01.014.018.02l3.64 3.765.004.004a.58.58 0 0 0 .058.048.388.388 0 0 0 .097.044c.014.004.024.01.038.01a.52.52 0 0 0 .072.008h8.782a.964.964 0 0 0 .963-.964V.964A.977.977 0 0 0 12.788 0Zm-9.15 16.064-2.403-2.485h1.993c.227 0 .41.182.41.41v2.075Zm9.377.316a.23.23 0 0 1-.227.227h-8.41v-2.615a1.15 1.15 0 0 0-1.147-1.15H.736V.965A.23.23 0 0 1 .964.736H12.79a.23.23 0 0 1 .227.228l-.003 15.416Z"
      />
      <path
        fill="#000D5B"
        d="M10.964 3.328H2.787a.369.369 0 0 0 0 .736h8.177a.369.369 0 0 0 0-.736ZM10.964 5.444H2.787a.369.369 0 0 0 0 .736h8.177a.369.369 0 0 0 0-.736ZM10.964 7.56H2.787a.369.369 0 0 0 0 .737h8.177a.369.369 0 0 0 0-.737ZM10.964 9.677H2.787a.369.369 0 0 0 0 .736h8.177a.369.369 0 0 0 0-.736Z"
      />
    </svg>
  );
}

import * as React from "react";
